import { call, put, takeLatest } from 'redux-saga/effects';

import { abortAndResetLogoutAbortController } from '@frontend/api';

import authService from 'services/authService';

import { setDidSessionExpire } from 'store/app/actions';
import { receiveUser, receiveAccessToken } from 'store/session/actions';

import history from 'utils/browserHistory';
import { removeToken } from 'utils/token';

import { types, loginInfo, logoutAll } from './actions';

export default function* root() {
  yield takeLatest(types.LOGOUT_ALL_SESSIONS_REQUEST, watchLogoutAllSessions);
}

function* watchLogoutAllSessions({ payload: { didSessionExpire } }) {
  try {
    abortAndResetLogoutAbortController('User is logging out');

    yield call(authService.logoutAll);
    yield call(removeToken);
    yield put(receiveAccessToken(null));
    yield put(receiveUser(null));

    abortAndResetLogoutAbortController('User was logged out');

    if (didSessionExpire) {
      yield put(setDidSessionExpire({ didSessionExpire }));
      const initialPage = window.location.pathname + window.location.search;
      history.push(`/login?next=${initialPage}`);
    } else {
      yield put(logoutAll.success());
      history.push('/login');
    }
  } catch (e) {
    yield put(logoutAll.error(e));
  }
}

export function* initSaga() {
  try {
    const loginActivity = yield call(authService.requestLoginInfo);
    yield put(loginInfo.success({ loginActivity }));
  } catch (error) {
    yield put(loginInfo.error(error));
  }
}
